import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Modal } from "reactstrap";
import { getCustomerMembership } from "../../../redux/cutomerMemb/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import UserFilter from "../User/UserFilter";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import Check from "../../assets/images/checkk.svg";
import Cross from "../../assets/images/cross.svg";
import ZatcaModal from "../Invoice/ZatcaModal";
import Spinner from "../../Layouts/Spinner";
import { invoiceReportValidation } from "./MemberShipReport";
import { useFormik } from "formik";
import ReactSelect from "react-select";
import * as XLSX from "xlsx";
import { getMembershipList } from "../../../redux/membership/action";
import axiosInstance from "../../../redux/api";
import { getUserList } from "../../../redux/invoice/action";
import { formatDate, formatDateInput } from "../../Common/Utils/dateUtils";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

const MemberShipReports = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [zatDetails, setZatDetails] = useState(null);
  const [zatcaMod, setZatcaMod] = useState(false);
  const [showFilter, setSHowFilter] = useState(false);
  const [selectStatus, setSlectStatus] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [exportLoader, setExportLoader] = useState(false);
  const [selectedOptionsMember, setSelectedOptionsMember] = useState();
  const [endDates, setEndDates] = useState("");
  const [startDates, setStartDates] = useState("");
  const [theFilterInfo, setTheFilterInfo] = useState({
    user_id: "",
    start_date: "",
    end_date: "",
    membership_id: "",
    status: "",
    testing_account_filter: "hide",
    type: "membership_report",
  });

  const customerMembershipList = useSelector(
    (state) => state?.reusableSlice?.customerMembershipList
  );
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
    type: 1,
    start_data: "",
    end_date: "",
    user_id: "",
    testing_account_filter: "hide",
  });

  useEffect(() => {
    dispatch(getUserList({ search_key: "" }));
    dispatch(getMembershipList({ search_key: "" }));
    dispatch(getCustomerMembership(params))
      .then((res) => {
        if (res.status) {
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => setLoading(false));
  }, [dispatch, params]);

  const handleZatcaDetails = (zat) => {
    setZatDetails(zat);
    setZatcaMod(true);
  };

  const userList = useSelector((state) => state?.reusableSlice?.userList);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_id: "",
      start_date: "",
      end_date: "",
      membership_id: "",
      status: "",
      testing_account_filter: "hide",
    },
    validationSchema: invoiceReportValidation,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (values) => {
      if (
        values.user_id ||
        values.membership_id ||
        values.status ||
        values.start_date ||
        values.end_date ||
        values.testing_account_filter !== "hide"
      ) {
        handleSubmit(values);
      }
      return;
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      type: 1,
      page: 1,
    };
    setTheFilterInfo(values);
    dispatch(getCustomerMembership(data))
      .then((res) => {
        if (res.status) {
          setLoading(false);
          setParams((prevParams) => ({
            ...prevParams,
            page: 1,
          }));
        } else {
          setLoading(false);
        }
      })
      .catch((e) => setLoading(false));
  };

  function extractDate(dateString) {
    return formatDateInput(dateString);
  }

  const handleExportReport = () => {
    setExportLoader(true);
    axiosInstance
      .post("membership/list_user_membership", theFilterInfo)
      .then((response) => {
        if (response.data.status) {
          setExportLoader(false);
          const header = [
            [
              "Sl",
              "Company",
              "Member ID",
              "Membership",
              "Price",
              "Duration Type",
              "Simplified Total",
              "Simplified Left",
              "VAT Total",
              "VAT Left",
              "Purchase Total",
              "Purchase Left",
              "Start Date",
              "End Date",
              "Invoice URL",
            ],
          ];
          const data = response.data.response.memberships.map((prop, index) => [
            index + 1,
            prop.company_name,
            prop.id,
            `${prop.membership_title} (${
              prop.duration_type === 1
                ? "M"
                : prop.duration_type === 2
                ? "A"
                : "D"
            })`,
            prop.total ?? prop.price,
            prop.duration_type === 1
              ? "Month"
              : prop.duration_type === 2
              ? "Annually"
              : "Days",
            prop.max_invoices == "10000" ? "Unlimited" : prop?.max_invoices,
            prop.invoice_left == "10000" ? "Unlimited" : prop?.invoice_left,
            prop.max_invoices1 == "10000" ? "Unlimited" : prop?.max_invoices1,
            prop.invoice_left1 == "10000" ? "Unlimited" : prop?.invoice_left1,
            prop.max_invoices2 == "10000" ? "Unlimited" : prop?.max_invoices2,
            prop.invoice_left2 == "10000" ? "Unlimited" : prop?.invoice_left2,
            extractDate(prop.start_date),
            extractDate(prop.end_date),
            prop.invoice,
          ]);
          const worksheet = XLSX.utils.aoa_to_sheet(header); // Add headers
          XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" }); // Add data starting from row 2
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "MembershipReport.xlsx");
        }
      })
      .catch((e) => {
        console.log(e, "while exporting reports");
        setExportLoader(false);
      });
  };

  const membershipList = useSelector(
    (state) => state?.reusableSlice?.membershipList
  );

  const proOptions =
    userList &&
    Array.isArray(userList.users) &&
    userList?.users?.map((item) => ({
      value: item?.id,
      label: item?.company_name,
    }));

  const proMembOptions = membershipList?.memberships?.map((item) => ({
    value: item?.id,
    label: `${item?.title} (${item.duration_type === 1 ? "Month" : "Annually"})`,
  }));

  const invoiceOptions = [
    {
      value: 1,
      label: "Active",
    },
    {
      value: 2,
      label: "Expired",
    },
  ];

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
  };
  const handleChangeMember = (selected) => {
    setSelectedOptionsMember(selected);
    formik.setFieldValue("membership_id", selected?.value);
  };

  const handleStartDateChange = (event) => {
    setStartDates(event.target.value);
    formik.setFieldValue("start_date", event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDates(event.target.value);
    formik.setFieldValue("end_date", event.target.value);
  };

  const handleSelectStatus = (stat) => {
    setSlectStatus(stat.values);
    formik.setFieldValue("status", stat.value);
  };

  const handleClearFilter = () => {
    if (
      formik.values.user_id ||
      formik.values.membership_id ||
      formik.values.status ||
      formik.values.start_date ||
      formik.values.end_date ||
      formik.values.testing_account_filter !== "hide"
    ) {
      setSelectedOptions("");
      setSlectStatus("");
      setStartDates("");
      setEndDates("");
      setTheFilterInfo({
        user_id: "",
        start_date: "",
        end_date: "",
        membership_id: "",
        status: "",
        testing_account_filter: "hide",
        type: "membership_report",
      });
      setSelectedOptionsMember("");
      formik.resetForm();
      setParams(() => ({
        page: 1,
        search_key: "",
        status: "",
        type: 1,
        start_data: "",
        end_date: "",
        user_id: "",
        testing_account_filter: "hide",
      }));
      dispatch(
        getCustomerMembership({
          page: 1,
          search_key: "",
          status: "",
          type: 1,
          start_data: "",
          end_date: "",
          user_id: "",
          testing_account_filter: "hide",
        })
      );
    }
    return;
  };

  return (
    <>
      {loading ? (
        <FullScreenLoader />
      ) : (
        <div>
          {/* <Modal isOpen={modals} toggle={() => setModals(!modals)}>
            <UserFilter
              modal={modals}
              setModal={setModals}
              params={params}
              setParams={setParams}
            />
          </Modal> */}

          <div className="p-3">
            <div className="category-wrapper">
              <div className=" d-flex justify-content-between align-items-center w-100 mb-3">
                <h4>Membership Invoices</h4>
                <div className="d-flex justify-content-between align-items-center ">
                  <button
                    type="button"
                    className="submit-btn  filter-btn mx-5"
                    onClick={() => setSHowFilter(!showFilter)}
                  >
                    <span>
                      <i className="fa-solid fa-filter"></i>{" "}
                      {showFilter ? "Hide Filter" : "Filter"}
                    </span>
                  </button>
                  <button
                    disabled={exportLoader}
                    type="button"
                    className="submit-btn"
                    onClick={() => handleExportReport()}
                    style={{ width: "max-content" }}
                  >
                    {exportLoader ? <Spinner /> : "Export"}
                  </button>
                </div>
              </div>
              {showFilter && (
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-3 form-group">
                      <label>Select Company</label>
                      <ReactSelect
                        isClearable
                        value={selectedOptions}
                        onChange={handleChange}
                        options={proOptions}
                        placeholder="Select Company"
                      />
                      {formik.touched.user_id && formik.errors.user_id ? (
                        <div className="error">{formik.errors.user_id}</div>
                      ) : null}
                    </div>
                    <div className="col-md-3 form-group">
                      <label>Select Membership</label>
                      <ReactSelect
                        isClearable
                        value={selectedOptionsMember}
                        onChange={handleChangeMember}
                        options={proMembOptions}
                        placeholder="select membership"
                      />
                      {formik.touched.membership_id &&
                      formik.errors.membership_id ? (
                        <div className="error">
                          {formik.errors.membership_id}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-md-3 form-group">
                      <label>Select Status</label>
                      <ReactSelect
                        name="status"
                        id="status"
                        value={selectStatus}
                        onChange={handleSelectStatus}
                        options={invoiceOptions}
                        placeholder="select status"
                      />
                      {formik.touched.membership_id &&
                      formik.errors.membership_id ? (
                        <div className="error">
                          {formik.errors.membership_id}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-md-3 form-group">
                      <label>Start Date</label>
                      <input
                        type="date"
                        className="form-control w-100"
                        placeholder="Enter start date"
                        value={startDates}
                        onChange={handleStartDateChange}
                        onBlur={formik.handleBlur}
                        name="start_date"
                      />
                      {formik.touched.start_date && formik.errors.start_date ? (
                        <div className="error">{formik.errors.start_date}</div>
                      ) : null}
                    </div>

                    <div className="col-md-3 form-group">
                      <label>End Date</label>
                      <input
                        type="date"
                        className="form-control w-100"
                        placeholder="Enter end date"
                        value={endDates}
                        onChange={handleEndDateChange}
                        onBlur={formik.handleBlur}
                        min={startDates || undefined}
                        name="end_date"
                      />
                      {formik.touched.end_date && formik.errors.end_date ? (
                        <div className="error">{formik.errors.end_date}</div>
                      ) : null}
                    </div>
                    <TestingAccountFilter
                      value={formik.values.testing_account_filter}
                      onChange={formik.handleChange}
                    />
                    <div
                      className="d-flex align-items-center justify-content-center mt-3 col-md-6 "
                      style={{ columnGap: "20px" }}
                    >
                      <button
                        className="submit-btn"
                        style={{ width: "max-content" }}
                        type="submit"
                      >
                        {!loading ? "Submit" : <Spinner />}
                      </button>
                      <button
                        type="button"
                        className="submit-btn"
                        onClick={() => handleClearFilter()}
                        style={{ width: "max-content" }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>

          <CardBody className="table-sec px-3">
            <table className="table border-table-sec">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Company</th>
                  <th scope="col">Membership</th>
                  <th scope="col">Price</th>

                  <th scope="col" colSpan="2" className="text-center">
                    Simplified
                  </th>
                  <th scope="col" colSpan="2" className="text-center">
                    VAT
                  </th>
                  <th scope="col" colSpan="2" className="text-center">
                    Purchase
                  </th>
                  <th scope="col">Reported</th>
                  <th scope="col">Signed</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>

                <tr>
                  <th colSpan="4"></th>
                  <th>Total</th>
                  <th>Left</th>
                  <th>Total</th>
                  <th>Left</th>
                  <th>Total</th>
                  <th>Left</th>
                  <th colSpan="2"></th>
                  <th colSpan="2"></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {customerMembershipList?.memberships?.length > 0 ? (
                  customerMembershipList?.memberships?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1 + (params?.page - 1) * 10}</td>
                      <td>{item?.company_name}</td>
                      <td>
                        {item?.membership_title} (
                        {item.duration_type === 1
                          ? "M"
                          : item.duration_type === 2
                          ? "A"
                          : "D"}
                        )
                      </td>
                      <td>{item?.total ?? item?.price}</td>
                      <td>
                        {item?.max_invoices == "10000"
                          ? "Unlimited"
                          : item?.max_invoices}
                      </td>
                      <td>
                        {item?.invoice_left == "10000"
                          ? "Unlimited"
                          : item?.invoice_left}
                      </td>
                      <td>
                        {item?.max_invoices1 == "10000"
                          ? "Unlimited"
                          : item?.max_invoices1}
                      </td>
                      <td>
                        {item?.invoice_left1 == "10000"
                          ? "Unlimited"
                          : item?.invoice_left1}
                      </td>
                      <td>
                        {item?.max_invoices2 == "10000"
                          ? "Unlimited"
                          : item?.max_invoices2}
                      </td>
                      <td>
                        {item?.invoice_left2 == "10000"
                          ? "Unlimited"
                          : item?.invoice_left2}
                      </td>
                      <td>
                        {" "}
                        {item?.onboarding === 0 ? (
                          <h5>--</h5>
                        ) : (
                          <img
                            src={
                              item?.zatca_status == "REPORTED" ? Check : Cross
                            }
                            alt=""
                          />
                        )}{" "}
                      </td>
                      <td>
                        {" "}
                        {item?.onboarding === 0 ? (
                          <h5>--</h5>
                        ) : (
                          <img
                            src={item?.signed_xml_url ? Check : Cross}
                            alt=""
                          />
                        )}{" "}
                      </td>

                      <td>
                        {formatDate(item?.start_date)}
                      </td>

                      <td>
                        {formatDate(item?.end_date)}
                      </td>
                      <td>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ columnGap: "10px" }}
                        >
                          {item?.invoice ? (
                            <button
                              className="border-button"
                              onClick={() => handleZatcaDetails(item)}
                            >
                              <span>View</span>
                            </button>
                          ) : item?.source_channel === "shopify" &&
                            Number(item?.total ?? item?.price ?? 0) === 0 ? (
                            <span className="text-muted small text-center">
                              Test subscription — no accounting invoice
                            </span>
                          ) : (
                            <span className="text-muted small text-center">
                              Invoice unavailable
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No membership invoice Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardBody>
          <Modal
            size="lg"
            isOpen={zatcaMod}
            className="zatca-modal"
            toggle={() => setZatcaMod(true)}
          >
            <ZatcaModal
              zatcaMod={zatcaMod}
              setZatcaMod={setZatcaMod}
              data={zatDetails}
            />
          </Modal>

          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={customerMembershipList?.pagination_meta}
          />
        </div>
      )}
    </>
  );
};

export default MemberShipReports;
